import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  GRAPH_PANEL_IMPORTS,
  GraphPanelComponent,
} from '../../../../panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-gas-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class GasGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.GasGraph;
  public override unit = DisplayUnit.M3;

  public override config: IGraphConfig = {
    sortOrder: [
      GraphType.EnergyPrice,
      GraphType.GasUsage,
      GraphType.EnergyEmission,
      GraphType.EnergyCosts,
      GraphType.GasGridManagementCosts,
      GraphType.GasTaxCosts,
      GraphType.GasVatCosts,
      GraphType.GasConsumptionCosts,
    ],
    legendSortOrder: [
      GraphType.GasUsage,
      GraphType.EnergyPrice,
      GraphType.EnergyEmission,
      GraphType.EnergyCosts,
      GraphType.GasConsumptionCosts,
      GraphType.GasGridManagementCosts,
      GraphType.GasTaxCosts,
      GraphType.GasVatCosts,
    ],
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.GasUsage:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Verbruikt', Color.Blue, DisplayUnit.M3);
      case GraphType.EnergyPrice:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Gasprijs',
          Color.DarkGreen,
          DisplayUnit.Euro,
          'line',
          {
            stepped: 'middle',
            hidden: true,
          },
        );
      case GraphType.EnergyCosts:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Kosten', Color.Yellow, DisplayUnit.Euro);

      case GraphType.GasConsumptionCosts:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Verbruikskosten',
          Color.Blue,
          DisplayUnit.Euro,
        );
      case GraphType.GasGridManagementCosts:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Netbeheer', Color.Green, DisplayUnit.Euro);
      case GraphType.GasTaxCosts:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Energiebelasting',
          Color.Yellow,
          DisplayUnit.Euro,
        );
      case GraphType.GasVatCosts:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'BTW', Color.Red, DisplayUnit.Euro);

      case GraphType.EnergyEmission:
        return generateDataset(dataset, startTimestamps, endTimestamps, 'Uitstoot', Color.Red, DisplayUnit.Kg);
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
